import { initializeApp } from 'firebase/app'
import {
  getAnalytics,
  logEvent,
  setUserProperties,
} from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, signInAnonymously } from 'firebase/auth'
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config'

// Edvi main
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_API_KEY,
  authDomain: 'edvi-main.firebaseapp.com',
  projectId: 'edvi-main',
  storageBucket: 'edvi-main.appspot.com',
  messagingSenderId: import.meta.env.VITE_FB_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FB_APP_ID,
  measurementId: import.meta.env.VITE_FB_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)

const auth = getAuth(app)

const remoteConfig = getRemoteConfig(app)

const signInFirebase = async () => {
  await signInAnonymously(auth)
  await fetchAndActivate(remoteConfig).catch((error) => {
    console.error(error)
  })
}

const analyticsInstance = getAnalytics(app)

// Compat-shaped wrapper so existing Analytics.js helpers keep working.
// setCurrentScreen was removed from the modular SDK; map to screen_view.
const analytics = {
  logEvent: (eventName, eventParams) =>
    logEvent(analyticsInstance, eventName, eventParams),
  setCurrentScreen: (screenName) =>
    logEvent(analyticsInstance, 'screen_view', {
      firebase_screen: screenName,
      firebase_screen_class: screenName,
    }),
  setUserProperties: (properties) =>
    setUserProperties(analyticsInstance, properties),
}

const db = getFirestore(app)

export { app as firebase, analytics, db, signInFirebase, remoteConfig }
